import React from 'react'
import { Text, View } from 'react-native'
import { darkLightColor, disabledGray } from '../../../theme/colors'

interface Props {
  currentState: string
  newState: string
}

export const DescriptionStates = ({ currentState, newState }: Props) => {
  return (
    <View>
      <Text style={{ color: disabledGray }}>Registro pendiente: Cambio de estado</Text>
      <Text style={{ color: disabledGray }}>Estado Actual: {currentState}</Text>
      <Text style={{ fontWeight: 'bold', color: darkLightColor }}>Nuevo Estado: {newState}</Text>
    </View>
  )
}
